import { createSlice } from '@reduxjs/toolkit';

const sessionStaleSlice = createSlice({
  name: 'sessionStale',
  initialState: {
    isStale: false,
  },
  reducers: {
    setSessionStale: (state) => {
      state.isStale = true;
    },
  },
});

export const { setSessionStale } = sessionStaleSlice.actions;
export default sessionStaleSlice.reducer;
